import { api } from "./client";
import type { LoginRequest, LoginResponse, LogoutRequest, RefreshRequest, RefreshResponse } from "./types";

export async function login(body: LoginRequest) {
  const { data } = await api.post<LoginResponse>("/auth/login", body);
  return data;
}

export async function refresh(body: RefreshRequest) {
  const { data } = await api.post<RefreshResponse>("/auth/refresh", body);
  return data;
}

export async function logout(body: LogoutRequest) {
  await api.post("/auth/logout", body);
}
